import React from "react";
import style from "./style.module.scss";
import TablePlaceholder from "../../../../images/v2/table_placeholder.png";
import ButtonIcon from "../ButtonIcon/ButtonIcon";
import useCommonStore from "../../stores/common";
import useDomainStore from "../../stores/domain";

function HiddenDataTable() {
  const { isKurvDomain } = useDomainStore();
  const toggleExpandDetails = useCommonStore(
    (state) => state.toggleExpandDetails,
  );

  return (
    <div className={`${style.hidden_data} ${isKurvDomain ? style.kurv_theme : ""}`}>
      <div className={style.img_container}>
        <img src={TablePlaceholder} className={style.blur_image} />
        <div className={style.expand_button}>
          <ButtonIcon
            bgColor={"#FFF"}
            textColor={isKurvDomain ? "#22A276" : "#4C70EF"}
            onClick={() => {
              toggleExpandDetails();
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96452 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM14.0306 15.2194C14.1003 15.2891 14.1556 15.3718 14.1933 15.4628C14.231 15.5539 14.2504 15.6515 14.2504 15.75C14.2504 15.8485 14.231 15.9461 14.1933 16.0372C14.1556 16.1282 14.1003 16.2109 14.0306 16.2806C13.9609 16.3503 13.8782 16.4056 13.7872 16.4433C13.6961 16.481 13.5986 16.5004 13.5 16.5004C13.4015 16.5004 13.3039 16.481 13.2128 16.4433C13.1218 16.4056 13.0391 16.3503 12.9694 16.2806L9.21938 12.5306C9.14965 12.461 9.09433 12.3783 9.05658 12.2872C9.01884 12.1962 8.99941 12.0986 8.99941 12C8.99941 11.9014 9.01884 11.8038 9.05658 11.7128C9.09433 11.6217 9.14965 11.539 9.21938 11.4694L12.9694 7.71937C13.0391 7.64969 13.1218 7.59442 13.2128 7.5567C13.3039 7.51899 13.4015 7.49958 13.5 7.49958C13.5986 7.49958 13.6961 7.51899 13.7872 7.5567C13.8782 7.59442 13.9609 7.64969 14.0306 7.71937C14.1003 7.78906 14.1556 7.87178 14.1933 7.96283C14.231 8.05387 14.2504 8.15145 14.2504 8.25C14.2504 8.34855 14.231 8.44613 14.1933 8.53717C14.1556 8.62822 14.1003 8.71094 14.0306 8.78063L10.8103 12L14.0306 15.2194Z"
                fill={isKurvDomain ? "#22A276" : "#4C70EF"}
              />
            </svg>
            <span>Expand to view table</span>
          </ButtonIcon>
        </div>
      </div>
    </div>
  );
}

export default HiddenDataTable;
